import { DateTime } from 'luxon';

class XhrRequestCache {
  private requestsToCache: string[];

  private constructor() {
    this.requestsToCache = [];
  }

  static with(requestsToCache: string[]) {
    const cache = new this();
    requestsToCache.forEach((request) => {
      cache.addRequestToCache(request);
    });
    return cache;
  }

  MINUTES_CACHE_LIFETIME = 15; // minutos

  async getValue(request: string, asyncGetterFn: (url: string) => Promise<any>): Promise<any> {
    if (!this.shouldCache(request)) return asyncGetterFn(request);

    const cachedValue = localStorage.getItem(request);
    const now = DateTime.fromJSDate(new Date());

    // Control de vencimiento de cache
    // *******************************
    if (cachedValue && JSON.parse(cachedValue).timestamp) {
      const tsCached = JSON.parse(cachedValue).timestamp;
      const dtCached = DateTime.fromFormat(tsCached, 'dd/LL/yyyy HH:mm');
      if (now.diff(dtCached, 'minutes').minutes < this.MINUTES_CACHE_LIFETIME) {
        console.log(`**** cache hit (${request})`);
        return JSON.parse(cachedValue).data
      }
    }
    console.log(`cache miss (${request})`);

    // Ejecuto la request
    // *******************************
    const newValue = await asyncGetterFn(request);
    const _ts = now.toFormat('dd/LL/yyyy HH:mm');

    // Actualizo cache
    // *******************************
    try {
          localStorage.setItem(request, JSON.stringify({ data: newValue, timestamp: _ts }));
    } catch (e) {
          console.warn('XhrRequestCache: localStorage full, clearing cache');
          this.reset();
    }

    return newValue;
  }

  addRequestToCache(request: string) {
    this.requestsToCache.push(request);
  }

  clear() {
    console.log(this.requestsToCache, 'XhrRequestCache: clearing entire cache');
    this.requestsToCache.forEach((r) => {
      this.clearOf(r);
    });
  }

  clearOf(aRequest: string) {
    console.log(aRequest, "aRequest");
    console.log(`XhrRequestCache: clearing cache of ${aRequest}`);
    localStorage.removeItem(aRequest);
  }

  reset(){
    this.requestsToCache.forEach((r) => {
      this.clearByPrefix(r);
    });
  }

  clearByPrefix(prefix: string) {
  for (let i = localStorage.length - 1; i >= 0; i--) {
    const key = localStorage.key(i);
    if (key?.startsWith(prefix)) {
      localStorage.removeItem(key);
    }
  }
}


 private shouldCache(request: string): boolean {
    const ret = this.requestsToCache.some((r) => request.startsWith(r));
    return ret;
  }
}

export default XhrRequestCache;
